module.exports = __webpack_public_path__ + "media/images/frontend/covid19-acecc1400c5fc16656d44cc7aecd4da8.svg";